<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idempresa" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Concepto de pago..."></multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,default:{type:Object,required:false,default:null},xdefault:{type:Object,required:false,default:null} },
    data(){
        return{
            datos: [],
            modelo: {
                idempresa: null, 
            }
        }
    },
    watch:{
        'modelo.idempresa': function(){this.model.concepto_pago_id=this.modelo.idempresa.id; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idempresa = a;
        },
        'xdefault.xnombre':function(){
            if( this.xdefault.xnombre ){
                let dat = this.datos.find( x => x.nombre == this.xdefault.xnombre )
                if( dat ) this.modelo.idempresa = dat;
            }
        },
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{ getConceptosPago(estado:true){ id nombre descripcion estado } }`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getConceptosPago;
                if( !vue.datos ) vue.datos = [];
                window.console.log( '>>>conceptos',vue.datos );
                if( this.default ){
                    this.modelo.idempresa = this.datos.find( x => x.id == this.default.id );
                }

                if( this.xdefault.xnombre ){
                    let dat = this.datos.find( x => x.nombre == this.xdefault.xnombre )
                    if( dat ) this.modelo.idempresa = dat;
                }

                // esto no deberia ir, es solo para corregir el grapgql no retorna valores
                if( vue.datos.length == 0 ){
                    window.console.log( 'CAMBIOS',this.xdefault )
                    if( this.xdefault.xnombre ){
                        let d = {
                            id: -1,
                            nombre: this.xdefault.xnombre,
                            descripcion: '',
                        }
                        this.datos.push( d );
                        this.modelo.idempresa = d;
                    }
                }
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getConceptosPago' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>